import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cookie-consent"
export default class extends Controller {
  static values = { consentPath: String }

  connect() {
  }

  sendConsent() {
    if (!this.consentPathValue) {
      console.error("Consent path value is missing.");
      return;
    }

    fetch(this.consentPathValue, {
      method: "GET"
    })
      .then(response => {
        if (response.ok) {
          this.element.remove()
        } else {
          console.error("Failed to send consent");
        }
      })
      .catch(error => console.error("Error:", error));
  }
}

